import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { PtvRecommendationsForMunicipality } from '@/api/types';

export function useQueryParams() {
  const { search } = useLocation();
  return useMemo(() => paramsToObject(new URLSearchParams(search)), [search]);
}

function paramsToObject(params: URLSearchParams) {
  const result: Record<string, string> = {};
  for (const [key, value] of params) {
    result[key] = value;
  }
  return result;
}

export function withUrlParams(path: string, params: Record<string, string>) {
  return `${path}?${new URLSearchParams(params).toString()}`;
}

function checkRecommendationNeed(answer: { [key: string]: string }) {
  // question with key 11 has backwards logic, hence we do this
  if (Object.keys(answer)[0] === '2') {
    return Number(Object.values(answer)[0]) > 3;
  } else {
    return Number(Object.values(answer)[0]) < 7;
  }
}

export function useParseRecommendationsPerAnswers(
  recommendations: PtvRecommendationsForMunicipality | undefined,
  answers: { [key: string]: string }[]
) {
  if (recommendations?.questions.length) {
    const answersNeedingRecommendation = answers
      .slice(2)
      .filter((answer) => checkRecommendationNeed(answer))
      .map((key) => Number(Object.keys(key)))
      .flat(1);
    const recommedantionsForAnsweredQuestions = recommendations.questions.map(
      (question) =>
        answersNeedingRecommendation.find((answerNumber) => {
          return answerNumber === Number(question.queryNumber);
        })
          ? question
          : null
    );
    return recommedantionsForAnsweredQuestions.filter(
      (element) => element != null
    );
  }
}
